export interface PlanMetadata {
  header: string;
  payDescriptionWeb: string;
  payInterval: string;
  planDescription: string;
  planTitle: string;
  pricePerInterval: string;
  shortPlan?: string;
  subheader: string;
  withoutDiscount: string;
  id: string;
  monthlyPrice: string;
  numberOfMonths: string;
  description: string;
  descriptionV2?: string;
  priceWithoutBargain?: string;
  position: string;
  label?: string;
  showInPlansList?: string;
  priceDescription?: string;
  isBestValue?: string;
  billingPeriodLabel?: string;
  enableProgram?: string;
  bullet1?: string;
  bullet2?: string;
  bullet3?: string;
  bullet4?: string;
  useOnlyInVariant?: string;
  paymentsPlanTitle?: string;
  paymentsPricingLabel?: string;
  paymentsSubtitle?: string;
  pricingLabel?: string;
  subtitle?: string;
  paymentDescription?: string;
  planHeader?: string;
  amountWithKlarnaInCents?: string;
  klarnaDescription?: string;
  weeklyPrice?: string;
  signupPlanTitle?: string;
}

export enum PlanType {
  OneTime = 'one_time',
  Recurring = 'recurring',
}

export interface Plan {
  id: string;
  amount: number;
  currency: string;
  metadata: PlanMetadata;
  interval: string;
  productId: string;
  type: PlanType;
}

export interface Plans {
  [key: string]: Plan;
}

export interface PlanDataExtracted {
  sanitizedHeader: string;
  sanitizedPlanDescription: string;
  sanitizedPlanTitle: string;
  sanitizedPayDescriptionWeb: string;
  sanitizedPayInterval: string;
  sanitizedCurrency: string;
  sanitizedPricePerInterval: string;
  sanitizedSubheader: string;
  sanitizedWithoutDiscount: string;
  sanitizedAmount: number;
  sanitizedAmountWithKlarnaInCents: number;
  sanitizedIsShortPlan: boolean;
  sanitizedId: string;

  sanitizedDescription: string;
  sanitizedKlarnaDescription: string;
  /**
   * Short = Not in cents. e.g 24.99
   */
  sanitizedMonthlyPriceShort: number;
  sanitizedWeeklyPriceShort: number;
  sanitizedPriceWithoutBargainShort: number;
  sanitizedNumberOfMonths: number;
  sanitizedInterval: 'month' | 'year' | string;
  sanitizedPlanType?: PlanType;
}
